'use client';
import React from 'react';
import subMonths from 'date-fns/subMonths';

import Layout from '../lib/components/Layout';
import CalendarService from '../lib/services/CalendarService';
import ColumnsDefinition from './ColumnsDef';
import { formatRequestDate } from '../lib/utils';
import { fetchOptions } from './Services';

import { ICalendarProps, IDateRange } from '../lib/interfaces';
import { UnusualOptionsActivity } from '@benzinga/calendar-manager';

export const fetchOptionsData = fetchOptions;
export const OptionsCalendarColumnsDef = ColumnsDefinition;

export const OptionsCalendar: React.FC<ICalendarProps> = ({
  calendar,
  calendarData,
  hasStockTableStyling,
  height,
  initialData,
  initialDateRange,
  initialTicker,
  leftSlot,
  onReady,
}) => {
  const [loading, setLoading] = React.useState(false);
  const [tableData, setTableData] = React.useState<UnusualOptionsActivity[]>(initialData || []);
  let dateRange: IDateRange;

  if (initialDateRange) {
    dateRange = initialDateRange;
  } else {
    dateRange = {
      date_from: formatRequestDate(subMonths(new Date(), 1)),
      date_to: formatRequestDate(new Date()),
    };
  }

  React.useEffect(() => {
    if (calendarData?.serverSide) {
      setTableData(initialData);
    }
  }, [initialData, calendarData]);

  function onTableReady() {
    if (initialData) {
      setTableData(initialData);

      if (onReady) {
        setTimeout(() => onReady());
      }
    } else {
      const params = {
        'parameters[date_from]': dateRange.date_from,
        'parameters[date_to]': dateRange.date_to,
      };
      if (initialTicker) {
        params['parameters[tickers]'] = initialTicker;
      }
      fetchData(params);

      if (onReady) {
        onReady();
      }
    }
  }

  function fetchData(filterParams: any) {
    const query = {
      ...filterParams,
      pagesize: 1000,
    };

    setLoading(true);

    const Calendar = new CalendarService();
    Calendar.getOptionActivitySignals(query)
      .then(({ data }: any) => {
        if (Array.isArray(data.option_activity)) {
          setTableData(data.option_activity.filter((item: any) => item.cost_basis > 500000));
        }
      })
      .finally(() => setLoading(false));
  }

  return (
    <Layout
      calendar={calendar}
      calendarData={calendarData}
      columnDefs={ColumnsDefinition}
      enableSearch
      hasStockTableStyling={hasStockTableStyling}
      height={height}
      initialDateRange={dateRange}
      isGated={true}
      leftSlot={leftSlot}
      onFilterChanged={fetchData}
      onTableReady={onTableReady}
      tableData={tableData}
      tableLoading={loading}
      ticker={initialTicker}
    />
  );
};
